module.exports = __webpack_public_path__ + "img/24.64d2cbab.jpg";